export default __webpack_public_path__ + "static/media/evolution.931c2994.svg";